import { Dispatch, SetStateAction } from "react";
import Pause from "../../../icons/pause.svg?react";
import Play from "../../../icons/play.svg?react";

const AudioControls = ({
  isPlaying,
  onPlayPauseClick,
}: {
  isPlaying: boolean;
  onPlayPauseClick: Dispatch<SetStateAction<boolean>>;
  onPrevClick?: () => void;
  onNextClick?: () => void;
}) => {
  const handleCLick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onPlayPauseClick(!isPlaying);
  };

  return (
    <div className="audio-controls">
      {isPlaying
        ? (
          <button
            type="button"
            className="pause"
            onClick={handleCLick}
            aria-label="Pause"
          >
            <Pause />
          </button>
        )
        : (
          <button
            type="button"
            className="play"
            onClick={handleCLick}
            aria-label="Play"
          >
            <Play />
          </button>
        )}
    </div>
  );
};

export default AudioControls;
